import redImg from "../../../../images/contents/map/acos/red.png";
import greenImg from "../../../../images/contents/map/acos/green.png"
import orangeImg from "../../../../images/contents/map/acos/orange.png"
import yellowImg from "../../../../images/contents/map/acos/yellow.png"

export const configVolcanicAshDh = {
  "Controller": {
    "Name": "ACOS"
  },
  "Source": {
    "index": {
      "Type": "Derived",
      "retain": "true"
    },
    "datalist": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_VolcanicAsh_GPV/index.json",
      "cache_busting": true,
      "retain": "true",
      "update_interval": 60
    },
    "timelist": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_VolcanicAsh_GPV/%id%/%type%/index.json",
      "cache_busting": true,
      "download_max": 32
    },
    "conf": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_VolcanicAsh_GPV/%id%/%type%/%basetime%/%level%/%validtime%.json",
      "cache": false,
      "download_max": 32
    },
    "data": {
      "Type": "GeoTiff",
      "url": "%wrap_url%/WX_WNI_VolcanicAsh_GPV/%id%/%type%/%basetime%/%level%/%validtime%.tiff",
      "download_max": 32
    }
  }
}

export const configVolcanicRankDh = {
  "data": {
    "Type":"GeoJSON",
    "url":"%wrap_url%/WX_WNI_VolcanicRank/latest.json",
    "update_interval": 60,
    "retain": true,
    "cache_busting": true
  },
  "index": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_WNI_VolcanicAshConcVector/index.json"
  },
  "volcano": {
    "Type": "JSON",
    "url": "%wrap_url%/WX_WNI_VolcanicAshConcVector/2D/%ptname%.json"
  }
}


export const configVolcanicAshLayer = {
  "Name" : "ACOS",
  "Renderer" : "ACOS",
  "Attributes" : {
    "3": {
      "line_color":"rgba(220, 107, 44, 1.0)",
      "line_width":1,
      "fill_color":"rgba(220, 107, 44, 0.5)"
    },
    "6": {
      "line_color":"rgba(234, 100, 255, 1.0)",
      "line_width":1,
      "fill_color":"rgba(234, 100, 255, 0.5)"
    },
    "9": {
      "line_color":"rgba(76, 158, 8, 1.0)",
      "line_width":1,
      "fill_color":"rgba(76, 158, 8, 0.5)"
    },
    "12": {
      "line_color":"rgba(255, 255, 0, 1.0)",
      "line_width":1,
      "fill_color":"rgba(255, 255, 0, 0.5)"
    },
    "15": {
      "line_color":"rgba(73, 221, 194, 1.0)",
      "line_width":1,
      "fill_color":"rgba(73, 221, 194, 0.5)"
    },
    "18": {
      "line_color":"rgba(35, 110, 241, 1.0)",
      "line_width":1,
      "fill_color":"rgba(35, 110, 241, 0.5)"
    },
    "21": {
      "line_color":"rgba(197, 78, 160, 1.0)",
      "line_width":1,
      "fill_color":"rgba(197, 78, 160, 0.5)"
    },
    "24": {
      "line_color":"rgba(106, 55, 167, 1.0)",
      "line_width":1,
      "fill_color":"rgba(106, 55, 167, 0.5)"
    }
  }
}

export const configVolcanicRankLayer = {
  "Name" : "VolcanicRank",
  "Renderer" : "GeoJSON",
  "Attributes" : {
      "features" : [
          {
              "selector" : {
                "type" : "key_value",
                "key" : "index",
                "value" : "1"
              },
              "style" : {
                  "default" : {
                      "type" : "image",
                      "width" : 20,
                      "height" : 18,
                      "offset_x" : -10,
                      "offset_y" : -9,
                      "url" : greenImg
                  }
              }
          },
          {
              "selector" : {
                "type" : "key_value",
                "key" : "index",
                "value" : "2"
              },
              "style" : {
                  "default" : {
                      "type" : "image",
                      "width" : 20,
                      "height" : 18,
                      "offset_x" : -10,
                      "offset_y" : -9,
                      "url" : yellowImg
                  }
              }
          },
          {
              "selector" : {
                "type" : "key_value",
                "key" : "index",
                "value" : "3"
              },
              "style" : {
                  "default" : {
                      "type" : "image",
                      "width" : 20,
                      "height" : 18,
                      "offset_x" : -10,
                      "offset_y" : -9,
                      "url" : orangeImg
                  }
              }
          },
          {
              "selector" : {
                "type" : "key_value",
                "key" : "index",
                "value" : "4"
              },
              "style" : {
                  "default" : {
                      "type" : "image",
                      "width" : 20,
                      "height" : 18,
                      "offset_x" : -10,
                      "offset_y" : -9,
                      "url" : redImg
                  }
              }
          }
      ]
  }
}
